export const SET_TIPO = 'tipo';
export const SET_LEVEL = 'level';
export const SET_DATA_INICIAL = 'dataInicial';
export const SET_DATA_FINAL = 'dataFinal';
